module.exports = "h4::before{\r\n    content: \"\\2014\";\r\n    font-size: inherit;\r\n    color:#ff000f;\r\n    display: block\r\n}"